import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-ohter-nft',
  templateUrl: './ohter-nft.component.html',
  styleUrls: ['./ohter-nft.component.scss']
})
export class OhterNftComponent implements OnInit {
  @Input() contract: string = "";
  @Input() token: string = "";

  constructor() { }

  ngOnInit(): void {
  }

}
